var env = window.env || process.env || {};
export default env;
